import { render } from "./reminders.vue?vue&type=template&id=04ec65f1&lang=pug"
import script from "./reminders.vue?vue&type=script&setup=true&lang=js"
export * from "./reminders.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__